import React from 'react';
import { Button, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ActViewDetail = ({ userInfo, setUserInfo, setOpenView }) => {
  const handleViewDetail = () => {
    setUserInfo(userInfo);
    setOpenView(true);
  };

  return (
    <Tooltip title="Chi tiết người dùng">
      <Button
        type="primary"
        icon={<EyeOutlined />}
        size="small"
        onClick={handleViewDetail}
        style={{
          marginRight: 8,
          backgroundColor: '#1890ff',
          borderColor: '#1890ff'
        }}
      />
    </Tooltip>
  );
};

export default ActViewDetail;
